export enum CommandTypes {
  add = 1,
  delete = 2,
  update = 3
}
